import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Divider,
  message,
  Modal,
  Icon,
  DatePicker,
} from "antd";
import {
  fetchCompanyStatistics,
  fetchEquipmentStatistics,
} from "../../../api/dataAnalysis";
import NProgress from "nprogress";

const BreadCrumbData = [
  { path: "/page/dataanalysis/dataanalysis", name: "数据统计" },
];
const { Column } = Table;
const { RangePicker } = DatePicker;
class DataAnalysis extends React.Component {
  state = {
    businessList: [],
    businessTotalSales: 0,
    businessTotalShare: 0,
    businessTotal: 0,
    businessListQuery: {
      field: "",
      rule: "",
      beginTime: "",
      endTime: "",
      pageSize: 10,
      pageNum: 1,
    },
    equipmentList: [],
    equipmentTotal: 0,
    equipmentListQuery: {
      field: "",
      rule: "",
      beginTime: "",
      endTime: "",
      pageSize: 10,
      pageNum: 1,
    },
  };
  businessDateChange = (date, dateString) => {
    this.setState(
      {
        businessListQuery: {
          ...this.state.businessListQuery,
          pageNum: 1,
          beginTime: dateString[0],
          endTime: dateString[1],
        },
      },
      () => this.getBusinessList()
    );
  };
  equipmentDateChange = (date, dateString) => {
    this.setState(
      {
        equipmentListQuery: {
          ...this.state.equipmentListQuery,
          pageNum: 1,
          beginTime: dateString[0],
          endTime: dateString[1],
        },
      },
      () => this.getEquipmentList()
    );
  };
  async componentDidMount() {
    NProgress.start();
    await this.getBusinessList();
    await this.getEquipmentList();
    NProgress.done();
  }
  getBusinessList = () => {
    fetchCompanyStatistics(this.state.businessListQuery).then((res) => {
      this.setState({
        businessList: res.data.searchResult.list,
        businessTotal: res.data.searchResult.total,
        businessTotalSales: res.data.totalSales,
        businessTotalShare: res.data.totalShare,
      });
    });
  };
  getEquipmentList = () => {
    fetchEquipmentStatistics(this.state.equipmentListQuery).then((res) => {
      this.setState({
        equipmentList: res.data.searchResult.list,
        equipmentTotal: res.data.searchResult.total,
        equipmentTotalSales: res.data.totalSales,
        equipmentTotalShare: res.data.totalShare,
      });
    });
  };
  businessChange = (pagination, filters, sorter) => {
    console.log(pagination);

    if (sorter.columnKey) {
      if (sorter.field === "totalSales") {
        this.setState(
          {
            businessListQuery: {
              ...this.state.businessListQuery,
              field: 0,
              pageNum: pagination.current,
              pageSize: pagination.pageSize,
              rule: sorter.order === "ascend" ? 1 : 0,
            },
          },
          () => this.getBusinessList()
        );
      } else {
        this.setState(
          {
            businessListQuery: {
              ...this.state.businessListQuery,
              field: 1,
              pageNum: pagination.current,
              pageSize: pagination.pageSize,
              rule: sorter.order === "ascend" ? 1 : 0,
            },
          },
          () => this.getBusinessList()
        );
      }
      this.setState({});
    } else {
      this.setState(
        {
          businessListQuery: {
            ...this.state.businessListQuery,

            pageNum: pagination.current,
            pageSize: pagination.pageSize,
          },
        },
        () => this.getBusinessList()
      );
    }
  };
  equipmentChange = (pagination, filters, sorter) => {
    if (sorter.columnKey) {
      if (sorter.field === "totalSales") {
        this.setState(
          {
            equipmentListQuery: {
              ...this.state.equipmentListQuery,
              field: 0,
              pageNum: pagination.current,
              pageSize: pagination.pageSize,
              rule: sorter.order === "ascend" ? 1 : 0,
            },
          },
          () => this.getEquipmentList()
        );
      } else {
        this.setState(
          {
            equipmentListQuery: {
              ...this.state.equipmentListQuery,
              field: 1,
              pageNum: pagination.current,
              pageSize: pagination.pageSize,
              rule: sorter.order === "ascend" ? 1 : 0,
            },
          },
          () => this.getEquipmentList()
        );
      }
    } else {
      this.setState(
        {
          equipmentListQuery: {
            ...this.state.equipmentListQuery,
            pageNum: pagination.current,
            pageSize: pagination.pageSize,
          },
        },
        () => this.getEquipmentList()
      );
    }
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  render() {
    const {
      businessTotalSales,
      businessTotalShare,
      businessTotal,
      businessListQuery,
      businessList,
      equipmentTotalSales,
      equipmentTotalShare,
      equipmentList,
      equipmentListQuery,
      equipmentTotal,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle" style={{ marginTop: 24 }}>
          <Row>
            <Col
              span={12}
              style={{ height: 32, lineHeight: "32px", fontSize: 16 }}
            >
              商户数据汇总
            </Col>
            <Col span={12} align="right">
              <RangePicker
                style={{ width: 320, textAlign: "left" }}
                onChange={this.businessDateChange}
              ></RangePicker>
            </Col>
          </Row>
          <div className="lineBetween"></div>
          <Table
            onChange={this.businessChange}
            rowKey="rank"
            dataSource={businessList}
            // locale={{ emptyText: "暂无商户" }}
            footer={(currentPageData) => {
              return (
                <React.Fragment>
                  <span
                    style={{
                      width: "60%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    总计
                  </span>
                  <span
                    style={{
                      width: "20%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    ￥{businessTotalSales}
                  </span>
                  <span
                    style={{
                      width: "20%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    ￥{businessTotalShare}
                  </span>
                </React.Fragment>
              );
            }}
            pagination={{
              showTotal: () => `共${businessTotal}条`,
              total: businessTotal,
              pageSize: businessListQuery.pageSize,
              current: businessListQuery.pageNum,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              //   onChange: (page, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageNum: page }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   },
              //   onShowSizeChange: (current, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageSize }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   }
            }}
          >
            <Column width="10%" title="排名" dataIndex="rank" key="rank" />
            <Column
              width="30%"
              title="商户"
              dataIndex="companyName"
              key="companyName"
            />
            <Column
              width="20"
              title="设备台数"
              dataIndex="capsuleNum"
              key="capsuleNum"
            />
            <Column
              width="20%"
              title="实际销售总额/元"
              dataIndex="totalSales"
              key="totalSales"
              sorter={true}
            />
            <Column
              width="20%"
              title="分账总额/元"
              dataIndex="totalShare"
              key="totalShare"
              sorter={true}
            />
          </Table>
        </div>
        <div className="searchTitle">
          <Row>
            <Col
              span={12}
              style={{ height: 32, lineHeight: "32px", fontSize: 16 }}
            >
              设备数据汇总
            </Col>
            <Col span={12} align="right">
              <RangePicker
                style={{ width: 320, textAlign: "left" }}
                onChange={this.equipmentDateChange}
              ></RangePicker>
            </Col>
          </Row>
          <div className="lineBetween"></div>
          <Table
            rowKey="rank"
            dataSource={equipmentList}
            onChange={this.equipmentChange}
            // locale={{ emptyText: "暂无商户" }}
            footer={(currentPageData) => {
              return (
                <React.Fragment>
                  <span
                    style={{
                      width: "65%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    总计
                  </span>
                  <span
                    style={{
                      width: "17.5%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    ￥{equipmentTotalSales}
                  </span>
                  <span
                    style={{
                      width: "17.5%",
                      display: "inline-block",
                      paddingLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    ￥{equipmentTotalShare}
                  </span>
                </React.Fragment>
              );
            }}
            pagination={{
              showTotal: () => `共${equipmentTotal}条`,
              total: equipmentTotal,
              current: equipmentListQuery.pageNum,
              pageSize: equipmentListQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              //   onChange: (page, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageNum: page }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   },
              //   onShowSizeChange: (current, pageSize) => {
              //     this.setState(
              //       {
              //         listQuery: { ...listQuery, pageSize }
              //       },
              //       () => this.getEmployeeList()
              //     );
              //   }
            }}
          >
            <Column width="6%" title="排行" dataIndex="rank" key="rank" />
            <Column
              width="10%"
              title="设备类型"
              dataIndex="capsuleType"
              key="capsuleType"
              render={this.renderType}
            />
            <Column
              width="12%"
              title="设备编号"
              dataIndex="capsuleNo"
              key="capsuleNo"
            />
            <Column
              width="17"
              title="所属商户"
              dataIndex="companyName"
              key="companyName"
            />
            <Column
              width="20"
              title="投放地点"
              dataIndex="address"
              key="address"
            />
            <Column
              width="17.5%"
              title="实际销售总额/元"
              dataIndex="totalSales"
              key="totalSales"
              sorter={true}
            />
            <Column
              width="17.5%"
              title="分账总额/元"
              dataIndex="totalShare"
              key="totalShare"
              sorter={true}
            />
          </Table>
        </div>
      </div>
    );
  }
}
export default DataAnalysis;
